import { render } from "./productConfigurationOption.vue?vue&type=template&id=7b36917b&scoped=true&ts=true"
import script from "./productConfigurationOption.vue?vue&type=script&lang=ts"
export * from "./productConfigurationOption.vue?vue&type=script&lang=ts"

import "./productConfigurationOption.vue?vue&type=style&index=0&id=7b36917b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b36917b"]])

export default __exports__